import React, { useState } from 'react';
import { Button, Toggle, Stack, TextInput } from '@carbon/react';
import { Select, SelectItem } from '@carbon/react';
import { DatePicker, DatePickerInput } from '@carbon/react';
import { Popover, PopoverContent } from '@carbon/react';
import { dateFormat } from '../../../Utils/constants';

export default function Filter(props) {
  const { isVerticle, handleChange, handleSubmit, handleSearch, formValue } =
    props;
  const [openDatePicker, setopenDatePicker] = useState(false);
  return !isVerticle ? (
    <div>
      <div className="search-box">
        <Stack gap={10}>
          <TextInput
            labelText=""
            placeholder="Search input text"
            name="search"
            value={formValue?.search || ''}
            onChange={handleChange}
            required={false}
            id="search"
          />
          <Button
            className="cursor-pointer black-button"
            // kind="primary"

            onClick={handleSearch}
            tabIndex={0}
            type="button"
          >
            Search
          </Button>
        </Stack>
      </div>
      <div className="filter-box">
        <div className="filter-select">
          <Select
            defaultValue="placeholder-item"
            id="select-1"
            invalidText="A valid value is required"
          >
            <SelectItem text="Choose an option" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>
        <div className="filter-select">
          <Popover open={openDatePicker} align="bottom" dropShadow caret>
            <div
              className="popover-trigger cursor-pointer"
              onClick={() => setopenDatePicker(!openDatePicker)}
            >
              Date Range:
            </div>
            <PopoverContent>
              <div className="popover-example-content">
                <DatePicker dateFormat={dateFormat} datePickerType="range">
                  <DatePickerInput
                    id="date-picker-range-start"
                    placeholder="mm/dd/yyyy"
                    labelText="Date picker label"
                    type="text"
                    disabled={false}
                    invalid={false}
                    size="md"
                  />
                  <DatePickerInput
                    id="date-picker-range-start"
                    placeholder="mm/dd/yyyy"
                    labelText="Date picker label"
                    type="text"
                    disabled={false}
                    invalid={false}
                    size="md"
                  />
                </DatePicker>
              </div>
            </PopoverContent>
          </Popover>
        </div>
        <div className="filter-select">
          <Select
            defaultValue="placeholder-item"
            id="select-1"
            invalidText="A valid value is required"
          >
            <SelectItem text="Choose an option" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>
        <div className="filter-select">
          <Select
            defaultValue="placeholder-item"
            id="select-2"
            invalidText="A valid value is required"
          >
            <SelectItem text="Choose an option" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>

        <Button
          className="cursor-pointer black-button"
          // kind="primary"
          onClick={handleSubmit}
          tabIndex={1}
          type="button"
        >
          Apply
        </Button>
      </div>
    </div>
  ) : (
    <div>
      <div className="filter-select">
        <TextInput
          labelText="Email"
          placeholder="Email"
          name="email"
          value={formValue?.email || ''}
          onChange={handleChange}
          required={false}
          id="email"
        />
        <br />
        <div className="checkbox-wraper">
          <div className="checkbox-align">
            <Toggle hideLabel labelText="Admin" id="Admin" />
          </div>
          <div className="checkbox-align">
            <Toggle hideLabel labelText="Active" id="Active" />
          </div>
        </div>
      </div>
      <div>
        <div className="filter-select">
          <Select
            labelText="Orginization unit"
            defaultValue="HR"
            id="select-2"
            invalidText="A valid value is required"
          >
            <SelectItem text="HR" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>
      </div>
      <div>
        <div className="filter-select">
          <Select
            labelText="Created Date"
            defaultValue="dates"
            id="select-2"
            invalidText="A valid value is required"
          >
            <SelectItem text="Created less then" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>
      </div>

      <div>
        <div className="filter-select">
          <div className="checkbox-wraper">
            <div className="checkbox-align">
              <Toggle hideLabel labelText="Have mail license" id="license" />
            </div>
          </div>
          <Select
            labelText="File Size"
            defaultValue="25mb"
            id="select-2"
            invalidText="A valid value is required"
          >
            <SelectItem text="25MB" value="placeholder-item" />

            <SelectItem text="Option 1" value="option-1" />
            <SelectItem text="Option 2" value="option-2" />

            <SelectItem text="Option 3" value="option-3" />
            <SelectItem text="Option 4" value="option-4" />
          </Select>
        </div>
      </div>
      <div>
        <Button
          className="cursor-pointer"
          kind="primary"
          onClick={handleSubmit}
          tabIndex={0}
          type="button"
        >
          Filter
        </Button>
        <Button
          className="cursor-pointer"
          kind="secondary"
          onClick={handleSubmit}
          tabIndex={0}
          type="button"
        >
          Reset
        </Button>
      </div>
    </div>
  );
}
